WiseMetering.Views.NewUser = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/users/new',
    className: 'mbx-info text-left',
    form_prefix: 'user',
    title: () => i18next.t('modal.title.users.new'),
    width: 470
});
